import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';

export const useIsMobile = (): boolean => {
    const breakpoints = useBreakpoint();
    return !!breakpoints?.xs;
};
